import {imManager} from '@/common-pages/im/im.state';

declare const window: {
  Android: any;
  jsBridge: any;
  onNotification: (data: any) => void;
  navigator: Navigator & {
    standalone: boolean;
  };
} & Window;

export const inApp = window?.navigator?.userAgent?.indexOf('Pandora') > -1;

export const inGameBox =
  window?.navigator?.userAgent?.indexOf('gamebox') > -1 || !!window?.jsBridge;

export function isPWA() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

export function getAdjustAttributionFromAPP() {
  const res = window.Android.getAdjustAttribution();
  if (res) {
    try {
      return JSON.parse(res);
    } catch (error) {
      return null;
    }
  }
  return res;
}

export function openURLInAPP(url: string) {
  try {
    window.Android.openURL(url);
  } catch (error) {
    console.log(error);
  }
}

export function getVersion() {
  const res =
    navigator.userAgent.match(/versionCode\/(\d+)/) ||
    navigator.userAgent.match(/AppVersion\/(\d+)/);
  if (res) {
    return res[1];
  }
  return '999';
}

export function getVersionName() {
  const res = navigator.userAgent.match(/versionName\/(.*)\s/);
  if (res) {
    return res[1];
  }
  return getVersion().split('').join('.');
}

export function setPushUniqueUser(id: string) {
  try {
    window.Android.setPushUniqueUser(id);
  } catch (error) {}
}

export function openURL(url: string) {
  try {
    // @ts-ignore
    window.jsBridge.postMessage('openWindow', JSON.stringify({url}));
  } catch (error) {}
}

export function openShare(text: string) {
  try {
    window.Android.shareText(text);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
}
export function getPushToken() {
  try {
    return window.Android.getPushToken();
  } catch (error) {
    return null;
  }
}
type NotificationData = {
  conversationID: string;
  fbSendTime: number;
};
let prevTime = -1;
window.onNotification = function (data) {
  const notifiation: NotificationData = JSON.parse(data || '{}');
  const {conversationID, fbSendTime} = notifiation;
  if (prevTime === fbSendTime) {
    return;
  }
  prevTime = fbSendTime;
  if (conversationID) {
    imManager.setVisibleState(true, {
      customerId: conversationID,
    });
  }
};
